import React from "react";
import { Card } from "../modules/Tenants";

export function TenantCardPage(props) {
  return <Card {...props} />;
}
